<script>
	import FusionCharts from 'fusioncharts';
  import Charts from 'fusioncharts/fusioncharts.charts';
  import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
  import SvelteFC, { fcRoot } from 'svelte-fusioncharts';

	fcRoot(FusionCharts, Charts, FusionTheme);

  export let points;
	export let label = "Nuovi positivi per regione";

	$: chartConfig = points.length > 0 ? {
		type: 'pie3d',
		width: '100%',
		height: '400',
		renderAt: 'chart-container',
		dataSource: { 
			chart: 
			{
				caption: label,
				subCaption : "",
				showValues:"1",
				showPercentInTooltip : "0",
				enableMultiSlicing:"1",
				theme: "fusion"
			},
			data:  points
	}
	} : {};
</script>


<div id="chart-container">
	{#if chartConfig && chartConfig.dataSource && chartConfig.dataSource.data && chartConfig.dataSource.data.length > 0}
		<SvelteFC {...chartConfig} />
	{/if}
</div>